import React from 'react';

import { Button, Switch } from '@mui/material';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { observer } from 'mobx-react';
import { TitleWithDescription, LbFormControlLabel } from '@infoods/lifebase-ui';

import { LbModal } from '../../../../shared/components/modals';
import { downloadFile } from '../../../../shared/utils/apiUtils';
import {
  challengeGuideLink,
  challengeGuideDownloadLink,
} from '../../../constants/externalLinks';
import classes from './ChallengeTutorialModal.module.scss';
import { Mode } from '../../../../general-types';

type ChallengeTutorialModalProps = {
  onClose: () => void;
  onShowAgainChange: (showAgain: boolean) => void;
  showAgain: boolean;
  mode: Mode;
  videoUrl: string | null;
};

const ChallengeTutorialModal = observer(
  ({
    mode,
    videoUrl,
    onClose,
    onShowAgainChange,
    showAgain,
  }: ChallengeTutorialModalProps) => {
    // Two separate S3 files: one without Content-Disposition header (opens inline in browser),
    // and one with Content-Disposition: attachment (forces browser download).
    const handleDownloadGuide = () => {
      downloadFile(challengeGuideDownloadLink, 'SWYMO_Challenge_Creation_Checklist.pdf');
    };

    return (
      <LbModal
        open={true}
        title="Tutorial to learn the challenge basic functions"
        text="If you encounter issues or forget features you can always replay this tutorial in the settings"
        renderBtnBox={
          <div className={classes.buttonColumn}>
            <Button
              variant="contained"
              size="medium"
              fullWidth
              href={challengeGuideLink}
              target="_blank"
              rel="noopener noreferrer"
              endIcon={<OpenInNewRoundedIcon />}
            >
              Open Challenge Guide
            </Button>
            <Button
              variant="contained"
              size="medium"
              fullWidth
              onClick={handleDownloadGuide}
            >
              Download Challenge Guide
            </Button>
            <Button variant="outlined" size="medium" fullWidth onClick={onClose}>
              Close
            </Button>
          </div>
        }
      >
        <div className={classes.container}>
          {videoUrl && (
            <iframe
              className={classes.video}
              title="Challenge Tutorial Video"
              src={videoUrl}
              allowFullScreen
            />
          )}
          {mode === 'EDIT' && (
            <LbFormControlLabel
              label={
                <TitleWithDescription
                  title="Don't Show Video Again"
                  description="You can get access to the video in the settings in your profile"
                  titleFont="title-16-bold"
                />
              }
              align="start"
              control={
                <Switch
                  checked={!showAgain}
                  onChange={(_, checked) => onShowAgainChange(!checked)}
                />
              }
            />
          )}
        </div>
      </LbModal>
    );
  },
);

export { ChallengeTutorialModal };
